import { render, staticRenderFns } from "./HistoricSites.vue?vue&type=template&id=b31861ea"
import script from "./HistoricSites.vue?vue&type=script&lang=js"
export * from "./HistoricSites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports